exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\napp-root{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  width:100%;\n  min-height: 100vh;\n  padding-top: 50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/app/wiserisk-core/src/main/ng4app/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/app/wiserisk-core/src/main/ng4app/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles